import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../ui/button';

type SettingsSectionLayoutProps = {
  title: string;
  onBack: () => void;
  children: React.ReactNode;
};

export function SettingsSectionLayout({ title, onBack, children }: SettingsSectionLayoutProps) {
  return (
    <div>
      <div className="mb-6">
        <Button type="button" variant="ghost" className="mb-4 -ml-2 gap-2" onClick={onBack}>
          <ArrowLeft className="h-4 w-4" />
          Back to Control Panel
        </Button>
        <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
      </div>
      {children}
    </div>
  );
}
